export const PLUGIN_BASE_PATH = 'plugins';
